/* 🤖 this file was generated by svg-to-ts */
export const matIconPowerInput: {
  name: 'power-input';
  data: string;
} = {
  name: 'power-input',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M2 9v2h19V9H2zm0 6h5v-2H2v2zm7 0h5v-2H9v2zm7 0h5v-2h-5v2z"/></svg>`
};
